/**
 * Word-level diff for change displays (operator order 2026-09-02): a
 * one-word fix reads as a one-word fix. Longest-common-subsequence over word
 * tokens; whitespace rides along unhighlighted. Pure and dependency-free so
 * the server test suite can exercise it directly.
 */
export function diffWords(before, after) {
  const a = String(before || '').split(/(\s+)/).filter((t) => t !== '');
  const b = String(after || '').split(/(\s+)/).filter((t) => t !== '');
  const n = a.length;
  const m = b.length;
  // A pathological pair falls back to whole-text marking rather than an
  // expensive table; the display stays correct, just less granular.
  if (n * m > 250000) {
    return {
      before: [{ text: String(before || ''), removed: true }],
      after: [{ text: String(after || ''), added: true }],
    };
  }
  const dp = Array.from({ length: n + 1 }, () => new Int32Array(m + 1));
  for (let i = n - 1; i >= 0; i -= 1) {
    for (let j = m - 1; j >= 0; j -= 1) {
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }
  const outA = [];
  const outB = [];
  let i = 0;
  let j = 0;
  while (i < n && j < m) {
    if (a[i] === b[j]) { outA.push({ text: a[i], same: true }); outB.push({ text: b[j], same: true }); i += 1; j += 1; }
    else if (dp[i + 1][j] >= dp[i][j + 1]) { outA.push({ text: a[i], removed: true }); i += 1; }
    else { outB.push({ text: b[j], added: true }); j += 1; }
  }
  while (i < n) { outA.push({ text: a[i], removed: true }); i += 1; }
  while (j < m) { outB.push({ text: b[j], added: true }); j += 1; }
  const calm = (t) => (/^\s+$/.test(t.text) ? { text: t.text, same: true } : t);
  return { before: outA.map(calm), after: outB.map(calm) };
}
